import api from './api';

const presupuestoService = {
  // Obtener todos los presupuestos
  getPresupuestos: async () => {
    try {
      const response = await api.get('/presupuestos');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener presupuesto por ID
  getPresupuestoById: async (id) => {
    try {
      const response = await api.get(`/presupuestos/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Crear nuevo presupuesto
  createPresupuesto: async (presupuestoData) => {
    try {
      const response = await api.post('/presupuestos', presupuestoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar presupuesto
  updatePresupuesto: async (id, presupuestoData) => {
    try {
      const response = await api.put(`/presupuestos/${id}`, presupuestoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar presupuesto
  deletePresupuesto: async (id) => {
    try {
      const response = await api.delete(`/presupuestos/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Cambiar estado del presupuesto
  cambiarEstado: async (id, estado) => {
    try {
      const response = await api.put(`/presupuestos/${id}/estado`, { estado });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener presupuestos por sucursal
  getPresupuestosPorSucursal: async (sucursal) => {
    try {
      const response = await api.get(`/presupuestos/sucursal/${sucursal}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Aceptar presupuesto y convertir a pedido
  aceptarPresupuesto: async (id, diasLimite = null) => {
    try {
      const data = diasLimite ? { diasLimite } : {};
      const response = await api.post(`/presupuestos/${id}/aceptar`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default presupuestoService;